import styled from '@emotion/styled';
import Popup from '~/components/Popup';

const BadgeContainer = styled('div')`
  display: flex;
  justify-content: left;
  width: 60px;
`;

const BadgeIconDiv = styled('div')`
  position: relative;
  height: 1.5rem;
  width: 1.5rem;
  top: 0.875rem;
  left: -21px;
  background-color: white;
  border-radius: 100%;
  box-shadow: 0 2px 4px 0 #d1d1d1;
  display: flex;
  align-items: center;
  justify-content: space-around;
`;

const BadgeImg = styled('img')`
  position: relative;
  display: block;
  padding: 6px;
`;

interface Props {
  svgSrc: string;
  badgeSrc?: string;
  tooltipText?: string;
}

// Source is combination an svg icon, plus an optional badge source
const IconWithBadge = (props: Props) => {
  const { svgSrc, badgeSrc, tooltipText } = props;
  return (
    <BadgeContainer>
      <BadgeImg src={svgSrc} />
      {badgeSrc && (
        <BadgeIconDiv>
          {tooltipText ? (
            <Popup
              position="top center"
              content={tooltipText}
              trigger={<BadgeImg src={badgeSrc} height="12" width="12" alt="badge" />}
              inverted
              size="mini"
            />
          ) : (
            <BadgeImg src={badgeSrc} height="12" width="12" alt="badge" />
          )}
        </BadgeIconDiv>
      )}
    </BadgeContainer>
  );
};

export default IconWithBadge;
